import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { partnerBundleEnvironment } from '../partner-bundle-environment';

/**
 * Requests the creation of an Api Key Bundle
 * @param bundleId The bundle ID
 * @param accountAlias The account alias
 * @param keyCount The key count
 * @returns Bundles
 */
export function postApikeysBundleCreateRequest(
  this: unknown,
  bundleId: number,
  accountAlias: string,
  keyCount: number
) {
  const requestUrl = partnerBundleEnvironment
    .resolve(this)
    .apiKeysBundleCreateRequest(bundleId);

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({
          accountAlias,
          keyCount,
        }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
      })
    )
  );
}
